export default "__VITE_ASSET__8f79cac3__"